import { render, staticRenderFns } from "./PopupCompinatePlate.vue?vue&type=template&id=041179e3&"
import script from "./PopupCompinatePlate.vue?vue&type=script&lang=js&"
export * from "./PopupCompinatePlate.vue?vue&type=script&lang=js&"
import style0 from "./PopupCompinatePlate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports